import React from 'react';
import { ProductImage } from 'anf-core-react';

export default function MobileZoomImage({
  productId,
  activeImage,
  altZoomImage,
  handleImageErrorOrRemoval,
}) {
  return (
    <ul className="product-zoom__images" data-testid="product-zoom-images-wrapper">
      <li className="product-zoom__image" data-collection={productId} tabIndex="-1" data-testid="mobile-image">
        <ProductImage
          classList="main-zoom-image"
          data-src={activeImage.zoomImageSrc}
          data-collection={productId}
          alt={altZoomImage(activeImage.type, activeImage.imageId.slice(-1))}
          src={activeImage.zoomImageSrc}
          onError={() => handleImageErrorOrRemoval(activeImage.imageId)}
        />
      </li>
    </ul>
  );
}
